export default [
    {
        Customers :"",
        warehouse :"",
        frequency :"",
        periodEnd :"",
        amount : "",
    },
  ];
  